module.exports = __webpack_public_path__ + "img/thereitis.c2f250fa.jpg";